<template>
  <div class="position-relative">
    <router-link :to="to" class="btn-cl mb-3 d-block mx-auto">
      <slot>
          <i class="fas fs-24"  :class="fasClass" ></i>
      </slot>
    </router-link>
    <label v-if="label" class="bg-dark text-white">{{ label }}</label>
  </div>
</template>

<script>
export default {
  name: 'sidebar-link',
  inheritAttrs:false,
  props:{
    fasClass: String,
    to: {
      type: String,
      default: '#'
    },
    label: String
  }
}
</script>

<style>

</style>